import React from 'react';
import Card from './Card/Card';

import css from './InvestmentOptions.module.scss';

import data from './data.json';

const InvestmenOptions = () => {
	return (
		<section className={css.investmentOptions}>
			<h2 data-aos="fade-up">One-stop-shop for your investment needs</h2>
			<div className={css.cards}>
				{data.map(({ id, src, alt, heading, description, link }) => (
					<Card
						key={id}
						src={src}
						alt={alt}
						heading={heading}
						description={description}
						link={link}
					/>
				))}
			</div>
		</section>
	);
};

export default InvestmenOptions;
